import { MessagingTemplateCreateMethodTypes } from "@enums/messaging-template-create-method-types";
import { SelectOption } from "@idw-types/common";

export const MESSAGING_TEMPLATE_CREATE_METHOD_OPTIONS: Array<SelectOption<MessagingTemplateCreateMethodTypes>> = [
    {
        label: "create a messaging template from scratch",
        value: MessagingTemplateCreateMethodTypes.CREATE_FROM_SCRATCH
    }
];